import React, { ReactNode } from 'react';
type CardProps = {
  children: ReactNode;
  highlighted?: boolean;
  className?: string;
};
export function Card({
  children,
  highlighted = false,
  className = ''
}: CardProps) {
  return <div className={`flex flex-col rounded-2xl border bg-surface p-[22px] md:p-[26px] ${highlighted ? 'border-accent/45 shadow-[0_0_0_1px_rgba(255,72,0,0.1),0_18px_40px_-24px_rgba(255,72,0,0.55)]' : 'border-line'} ${className}`} data-id="element-23" data-mp="2dxfxtgxztjdk">
      {children}
    </div>;
}
export function CardTag({
  children
}: {
  children: ReactNode;
}) {
  return <div className="mb-2 text-[10.5px] font-extrabold uppercase tracking-[0.1em] text-accent-soft" data-id="element-24" data-mp="2iug33pn0qi3m">{children}</div>;
}
export function CardFoot({
  children
}: {
  children: ReactNode;
}) {
  return <div className="mt-auto border-t border-line pt-4 text-[13.5px] leading-relaxed text-muted" data-id="element-25" data-mp="2sog71o6kdhar">{children}</div>;
}